import { ScrollView, Text, View, useColorScheme } from 'react-native';
import React, { Suspense, memo, lazy } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';

const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const NetworkingMenu = ({ navigation }) => {
  const { t } = useTranslation();
  return (
    <DefaultScreen style={{ paddingLeft: 2, paddingRight: 3 }}>
      <XStack flexWrap='wrap' gap={20} columnGap={20} style={{ gap: 5, marginBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
          <MenuIconCard pressFunction={() => {
            navigation.navigate('Map')
          }} subtitle="View your network on an interactive map" cardTitle="Map">
            <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
          </MenuIconCard>
          <MenuIconCard pressFunction={() => {
            navigation.navigate('Profiles')
          }} subtitle="Browse and manage professional profiles" cardTitle="Profiles">
            <LazyLottieView source={require('@assets/animations/star.json')} loop={false} style={{ width: '80%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
          </MenuIconCard>
        <MenuIconCard beta pressFunction={() => navigation.navigate('Meet')} subtitle="Schedule and manage meetings" cardTitle="Meet">
            <LazyLottieView source={require('@assets/animations/42404-add-document.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
          </MenuIconCard>
        {/* <MenuIconCard pressFunction={() => navigation.navigate('Search')} subtitle="Search for connections and companies" cardTitle="Search">
            <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
          </MenuIconCard> */}
        </XStack>
    </DefaultScreen >
  )
}
export default memo(NetworkingMenu);